import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import Main from './Components/Main/Main';
import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';
import { useState } from 'react';

function App() {

  const [titleClicked, setTitleClicked] = useState(false);

  const handleVideoSelected = (videoSelected) => {
    setTitleClicked(videoSelected);
  }

  const handleBackClick = (isSelected) => {
    setTitleClicked(isSelected);
  }

  console.log("title clicked! " + titleClicked);

  return (
    <Router>
      <div className={`app-container ${titleClicked ? 'video-selected' : ''}`}>
        <Header onVideo={titleClicked} videoSelected={handleBackClick} />
        <Main onVideo={titleClicked} videoSelected={handleVideoSelected}/>
        <Footer onVideo={titleClicked} videoSelected={handleBackClick}/>
      </div>
    </Router>
  );
}

export default App;
